function _extends() {return _extends = Object.assign ? Object.assign.bind() : function (n) {for (var e = 1; e < arguments.length; e++) {var t = arguments[e];for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);}return n;}, _extends.apply(null, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import { captureException } from '@sentry/react';
import { Translate } from "../../../../../I18N";

import { isClient } from "../../../../../utils";
import { lookup } from "../../../../api/search";
import {
  defaultSearch,
  InputField,
  MultiselectList,

  Textarea } from "../../../../Components/Forms";

import { Button } from "../../../../Components/UI";
import { thesauriAtom } from "../../../../atoms";
import { loadValuesAndSuggestions } from "../helpers";
import { selectionErrorAtom, textSelectionAtom } from "./atoms";

import { MultiselectItemLabel } from "./MultiselectItemLabel";
import { selectAndSearchAtom } from "./atoms/selectAndSearchAtom";

const updateOptionsWithSelection = (
options,
selectedValues) =>

options.map((option) => {var _option$items;return _objectSpread(_objectSpread({},
  option), {}, {
    label: /*#__PURE__*/React.cloneElement(option.label, {
      isSelected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(option.value)
    }),
    items: (_option$items = option.items) === null || _option$items === void 0 ? void 0 : _option$items.map((subItem) => _objectSpread(_objectSpread({},
    subItem), {}, {
      label: /*#__PURE__*/React.cloneElement(subItem.label, {
        isSelected: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.includes(subItem.value)
      }) })
    ) });}
);

const getSuggestionValues = (suggestedValue) => {
  if (!Array.isArray(suggestedValue)) return [String(suggestedValue)];
  return suggestedValue.map((value) => {
    if (value && typeof value === 'object' && 'id' in value) {
      return value.id;
    }
    return String(value);
  });
};

const calculateSearchText = (toggle, previousText, nextText) => {
  if (toggle) {
    return nextText || '';
  }
  return previousText || '';
};








const Selects = ({
  property,
  suggestion



}) => {
  const { control } = useFormContext();
  const thesauri = useAtomValue(thesauriAtom);
  const thesaurus = thesauri.find((item) => item._id === property.content);
  const selectedtext = useAtomValue(textSelectionAtom);
  const selectAndSearch = useAtomValue(selectAndSearchAtom);
  const searchTextRef = useRef('');
  const suggestions = getSuggestionValues(suggestion === null || suggestion === void 0 ? void 0 : suggestion.suggestedValue);
  const intialOptions = useMemo(
    () =>
    thesaurus === null || thesaurus === void 0 ? void 0 : thesaurus.values.map((value) => {var _value$values;return {
        label: /*#__PURE__*/
        _jsx(MultiselectItemLabel, {
          isSuggested: suggestions.includes(value.id),
          label: value.label,
          property: property }
        ),

        searchLabel: value.label.toLowerCase(),
        value: value.id,
        suggested: suggestions === null || suggestions === void 0 ? void 0 : suggestions.includes(value.id),
        items: (_value$values = value.values) === null || _value$values === void 0 ? void 0 : _value$values.map((subValue) => ({
          label: /*#__PURE__*/
          _jsx(MultiselectItemLabel, {
            isSuggested: suggestions.includes(subValue.id),
            label: subValue.label,
            property: property }
          ),

          searchLabel: subValue.label.toLowerCase(),
          value: subValue.id,
          suggested: suggestions === null || suggestions === void 0 ? void 0 : suggestions.includes(subValue.id)
        }))
      };}),
    [property, suggestions, thesaurus]
  );
  const [items, setItems] = useState(intialOptions || []);

  return (/*#__PURE__*/
    _jsx("div", { className: "h-60" }, void 0, /*#__PURE__*/
    _jsx(Controller, {
      control: control,
      name: "field",
      rules: { required: property === null || property === void 0 ? void 0 : property.required },
      render: ({ field: { value, onChange } }) => {
        const itemsWithSuggestions = updateOptionsWithSelection(items || [], value);
        searchTextRef.current = calculateSearchText(
          !!selectAndSearch,
          searchTextRef.current,
          selectedtext === null || selectedtext === void 0 ? void 0 : selectedtext.text
        );

        return (/*#__PURE__*/
          _jsx(MultiselectList, {
            onChange: onChange,
            onSearch: (s) => {
              setItems(() => defaultSearch(s, intialOptions));
            },
            selectedValues: value,
            items: itemsWithSuggestions,
            checkboxes: true,
            singleSelect: property.type === 'select',
            search: searchTextRef.current,
            suggestions: true }
          ));

      } }
    )
    ));

};

const Relationships = ({
  property,
  suggestion



}) => {
  const intitialOptionsRef = useRef([]);
  const { control } = useFormContext();
  const selectedtext = useAtomValue(textSelectionAtom);
  const selectAndSearch = useAtomValue(selectAndSearchAtom);
  const [options, setOptions] = useState([]);
  const searchTextRef = useRef('');

  useEffect(() => {
    if (suggestion && (property === null || property === void 0 ? void 0 : property.type) === 'relationship') {
      const suggestions = getSuggestionValues(suggestion === null || suggestion === void 0 ? void 0 : suggestion.suggestedValue);

      Promise.all([
      lookup({ entityTitle: '', template: property === null || property === void 0 ? void 0 : property.content }),
      ...(suggestion ?
      [
      loadValuesAndSuggestions(
        suggestion.currentValue,
        suggestions,
        suggestion.language
      )] :

      [])]
      ).
      then(([emptySearchResult, suggestedEntities]) => {
        const intialOptions = [...suggestedEntities, ...emptySearchResult.rows].reduce(
          (acc, option) => {
            if (!acc.find((_option) => _option.value === option.sharedId)) {
              acc.push({
                label: /*#__PURE__*/
                _jsx(MultiselectItemLabel, {
                  isSuggested: suggestions.includes(option.sharedId),
                  label: option.title,
                  property: property }
                ),

                value: option.sharedId,
                searchLabel: option.title,
                suggested: suggestions === null || suggestions === void 0 ? void 0 : suggestions.includes(option.sharedId)
              });
            }

            return acc;
          },
          []
        );

        intitialOptionsRef.current = intialOptions;
        setOptions(intialOptions);
      }).
      catch((e) => {
        if (isClient) {
          const error = new Error('Lookup search error', { cause: e });
          captureException(error);
        }
      });
    }
  }, [property, suggestion]);

  const lookupSearch = async (searchTerm) => {
    if (!searchTerm) {
      setOptions(intitialOptionsRef.current);
    } else {
      const response = await lookup({
        entityTitle: searchTerm || '',
        template: property === null || property === void 0 ? void 0 : property.content
      });

      const suggestions = getSuggestionValues(suggestion === null || suggestion === void 0 ? void 0 : suggestion.suggestedValue);

      setOptions(() =>
      response.rows.map((option) => ({
        label: /*#__PURE__*/
        _jsx(MultiselectItemLabel, {
          isSuggested: suggestions.includes(option.sharedId),
          label: option.title,
          property: property }
        ),

        value: option.sharedId,
        searchLabel: option.title,
        suggested: suggestions === null || suggestions === void 0 ? void 0 : suggestions.includes(option.sharedId)
      }))
      );
    }
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "h-60" }, void 0, /*#__PURE__*/
    _jsx(Controller, {
      control: control,
      name: "field",
      rules: { required: property === null || property === void 0 ? void 0 : property.required },
      render: ({ field: { value, onChange } }) => {
        const itemsWithSuggestions = updateOptionsWithSelection(options || [], value);
        searchTextRef.current = calculateSearchText(
          !!selectAndSearch,
          searchTextRef.current,
          selectedtext === null || selectedtext === void 0 ? void 0 : selectedtext.text
        );

        return (/*#__PURE__*/
          _jsx(MultiselectList, {
            onChange: onChange,
            selectedValues: value,
            items: itemsWithSuggestions,
            checkboxes: true,
            singleSelect: property.type === 'select',
            search: searchTextRef.current,
            suggestions: true,
            onSearch: lookupSearch }
          ));

      } }
    )
    ));

};

const TextInput = ({
  handleClickToFill,
  property,
  suggestion,
  clearSelectionButton





}) => {var _errors$field, _errors$field2;
  const {
    register,
    setValue,
    formState: { errors, isSubmitting }
  } = useFormContext();

  const selectionError = useAtomValue(selectionErrorAtom);

  const templateId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.entityTemplateId;

  let inputType = 'text';

  switch (property.type) {
    case 'numeric':
      inputType = 'number';
      break;
    case 'date':
      inputType = 'date';
      break;
    default:
      break;
  }

  return (/*#__PURE__*/
    _jsx("div", { className: "flex gap-2 grow items-center" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "grow" }, void 0, /*#__PURE__*/
    React.createElement(InputField, _extends({
      clearFieldAction: () => {
        setValue('field', '');
      },
      id: property.label,
      label: /*#__PURE__*/_jsx(Translate, { context: templateId }, void 0, property.label),
      hideLabel: true,
      type: inputType,
      hasErrors: ((_errors$field = errors.field) === null || _errors$field === void 0 ? void 0 : _errors$field.type) === 'required' || !!selectionError
      // eslint-disable-next-line react/jsx-props-no-spreading
    }, register('field', {
      required: property.required || property.name === 'title',
      valueAsDate: property.type === 'date' || undefined
    }), {
      errorMessage:
      ((_errors$field2 = errors.field) === null || _errors$field2 === void 0 ? void 0 : _errors$field2.type) === 'required' && /*#__PURE__*/
      _jsx(Translate, { className: "sr-only" }, void 0, "This field is required") })


    )
    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "outline",
      onClick: async () => handleClickToFill(),
      disabled: isSubmitting }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "" }, void 0, "Click to fill")
    )
    ),
    clearSelectionButton
    ));

};

const Markdown = ({
  handleClickToFill,
  suggestion,
  property,
  clearSelectionButton





}) => {
  const {
    control,
    setValue,
    formState: { isSubmitting, errors }
  } = useFormContext();
  const selectionError = useAtomValue(selectionErrorAtom);
  const templateId = suggestion === null || suggestion === void 0 ? void 0 : suggestion.entityTemplateId;

  return (/*#__PURE__*/
    _jsx("div", { className: "relative flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Controller, {
      control: control,
      name: "field",
      rules: { required: property === null || property === void 0 ? void 0 : property.required },
      render: ({ field: { onChange, value } }) => {var _errors$field3, _errors$field4;return (/*#__PURE__*/
          _jsx(Textarea, {
            id: property.name,
            label: /*#__PURE__*/_jsx(Translate, { context: templateId }, void 0, property.label),
            hideLabel: true,
            value: value,
            onChange: onChange,
            className: "grow",
            disabled: isSubmitting,
            hasErrors: ((_errors$field3 = errors.field) === null || _errors$field3 === void 0 ? void 0 : _errors$field3.type) === 'required' || !!selectionError,
            clearFieldAction: () => setValue('field', ''),
            errorMessage:
            ((_errors$field4 = errors.field) === null || _errors$field4 === void 0 ? void 0 : _errors$field4.type) === 'required' && /*#__PURE__*/
            _jsx(Translate, { className: "sr-only" }, void 0, "This field is required") }


          ));} }

    ), /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      styling: "outline",
      onClick: async () => handleClickToFill(),
      disabled: isSubmitting }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "" }, void 0, "Click to fill")
    )
    ),
    clearSelectionButton
    ));

};

const SidepanelForms = ({
  property,
  suggestion,
  handleClickToFill,
  clearSelectionButton
}) => {
  switch (property === null || property === void 0 ? void 0 : property.type) {
    case 'select':
    case 'multiselect':
      return /*#__PURE__*/_jsx(Selects, { suggestion: suggestion, property: property });
    case 'relationship':
      return /*#__PURE__*/_jsx(Relationships, { suggestion: suggestion, property: property });
    case 'text':
    case 'date':
    case 'numeric':
      return (/*#__PURE__*/
        _jsx(TextInput, {
          handleClickToFill: handleClickToFill,
          suggestion: suggestion,
          property: property,
          clearSelectionButton: clearSelectionButton }
        ));

    case 'markdown':
      return (/*#__PURE__*/
        _jsx(Markdown, {
          handleClickToFill: handleClickToFill,
          suggestion: suggestion,
          property: property,
          clearSelectionButton: clearSelectionButton }
        ));

    default:
      return '';
  }
};

export { SidepanelForms };